(function() {
    const bgImageWrapper = document.getElementById("background-images");
    const layers = Array.from(document.querySelectorAll('.background-image'));
    layers.forEach((el, i) => {
        if(!bgImageWrapper) return;
        let hold = parseInt(bgImageWrapper.dataset.bgImageChangeThreshold);
        hold === 0 ? hold = 1000 : hold;
        el.style.setProperty('--hold', isFinite(hold) ? hold + 'px' : '0px');
        el.style.setProperty('--z', 10 + i);
        
        const spacer = document.createElement('div');
        spacer.className = 'background-image-spacer';
        spacer.style.setProperty('--hold', getComputedStyle(el).getPropertyValue('--hold'));
        spacer.setAttribute('aria-hidden', 'true');

        el.after(spacer);
    });
})();